module.exports = __webpack_public_path__ + "img/ryan.ba073cd5.jpg";